import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogBase, T4RentalService } from 't4core';

@Component({
  selector: 't4-ThefttDialog',
  templateUrl: 'TheftDialog.html',
})
export class TheftDialog extends DialogBase implements OnInit {

  constructor(public dialogRef: MatDialogRef<TheftDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private rentalService: T4RentalService) {
    super("RefundDialog");
  }

  ngOnInit(): void {

  }

  public override() {
    this.dialogRef.close(true);
  }

  public close() {
    this.dialogRef.close();
  }
}
